import { Action, combineReducers } from '@reduxjs/toolkit'

import { authReducer, IAuthReducer } from 'store/auth/reducer'
import { certificatesReducer, ICertificatesReducer } from 'store/certificates/reducer'
import { countriesReducer, type CountriesReducer } from 'store/countries/reducer'
import { customersReducer, ICustomersReducer } from 'store/customers/reducer'

export interface RootState {
  auth: IAuthReducer;
  certificates: ICertificatesReducer;
  customers: ICustomersReducer;
  countries: CountriesReducer;
}

const appReducer = combineReducers({
  auth: authReducer,
  certificates: certificatesReducer,
  customers: customersReducer,
  countries: countriesReducer,
})

const rootReducer = (state: RootState, action: Action<any>) => {
  if (action.type === 'LOGOUT_USER') {
    return appReducer(undefined, action)
  }

  return appReducer(state, action)
}

export default rootReducer
